<template lang="pug">
  div
    v-navigation-drawer(v-model='drawer' app clipped)
      v-list(dense)
        v-list
          v-list-group(v-for='item in items' :key='item.title' v-model='item.active' :prepend-icon='item.icon' @click="redirect(item.title.toLowerCase())")
            template(v-slot:activator)
              //- router-link(:to="'/' + item.title.toLowerCase()" tag="button")
              v-list-item-content
                v-list-item-title(v-text='item.title')
            v-list-item(v-for='subItem in item.items' :key='subItem.title' :to="'/' + subItem.title.toLowerCase()")
              v-list-item-action
                v-icon.ml-4(color='grey darken-1') {{ subItem.icon }}
              v-list-item-title(v-text='subItem.title')
        v-divider
        v-list-item(@click="logout")
          v-list-item-action
            v-icon(color='grey darken-1') mdi-logout
          v-list-item-title.grey--text.text--darken-1 Logout
    v-app-bar(app clipped-left color='red' dense)
      v-app-bar-nav-icon(@click.stop='drawer = !drawer')
      v-toolbar-title.align-center
        v-row
          v-col.py-0
            v-img.mt-1(src="@/assets/images/arba_logo_2.png" width="70")
          v-col.py-0
            div.mt-n1.title Administrator
      v-spacer
      v-toolbar-title.align-center {{ $store.state.username.toUpperCase() }} &nbsp;
        v-chip.mx-1(v-for="group in groups" :color="group === 'Production' ? 'grey darken-2' : 'red darken-4'" small) {{ group }}
    v-content.pb-6
      v-container.fill-height
        router-view
</template>

<script>
export default {
  name: 'DashboardBar',
  data: () => ({
    drawer: null,
    items: [
      // { icon: 'mdi-truck-fast', title: 'Provider' },
      {
        icon: 'mdi-package-variant',
        title: 'Product',
        active: true,
        items: [
          // { icon: 'mdi-ticket', title: 'Clazzs' },
          // { icon: 'mdi-account-group-outline', title: 'Option' },
          { icon: 'mdi-tag-text-outline', title: 'Features' },
          { icon: 'mdi-home-city-outline', title: 'Cities' },
          { icon: 'mdi-account-group-outline', title: 'Options' }
        ]
      },
    ],
    groups: []
  }),
  mounted () {
    this.groups = this.$store.state.groups
  },
  methods: {
    logout () {
      this.$router.push('/')
      this.$store.commit('logout')
    },
    redirect (val) {
      if (this.$route.name !== val){
        this.$router.replace({ name: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>